<template>
    <div>
        <h3>NIMP Stock Levels</h3>
        <p>Current Nu-Wall stock levels held at P-88.</p>
        <v-text-field v-model="searchTerm"
                      label="Search product..."
                      density="compact"
                      hide-details
                      clearable
                      prepend-inner-icon="mdi-magnify"
                      class="my-2"></v-text-field>
        <v-skeleton-loader v-if="loading" type="table-tbody"></v-skeleton-loader>
        <div v-else-if="!loading && stock.length === 0" class="text-medium-emphasis text-body-2 py-2">
            No stock data available.
        </div>
        <v-table v-else density="compact">
            <thead>
                <tr>
                    <th class="text-left">Product</th>
                    <th class="text-right">Length (mm)</th>
                    <th class="text-right">Stock</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in filteredStock" :key="index">
                    <td><span v-html="formatSearchName(item.productDescription, searchTerm)"></span></td>
                    <td class="text-right">{{ item.length }}</td>
                    <td class="text-right">{{ item.stockLevel }}</td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>
<style scoped>
    :deep(.highlight-text) {
        background-color: #FFF176;
        font-weight: bold;
    }
</style>
<script>
    import { formatSearchName } from '../mixins/searchMixins';
    import { mapActions } from 'vuex';
    function initialState() {
        return {
            loading: false,
            stock: [],
            searchTerm: ''
        };
    }
    export default {
        name: "NimpStock",
        data() {
            return initialState();
        },
        mounted() {
            this.loadStock();
        },
        methods: {
            ...mapActions(['showErrorSnack']),
            formatSearchName,
            loadStock() {
                this.loading = true;
                this.$api.get('stock/nimpstock')
                    .then(res => {
                        this.stock = res.data;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.showErrorSnack('Failed to load NIMP stock levels.');
                        this.loading = false;
                    });
            }
        },
        computed: {
            filteredStock() {
                if (!this.searchTerm || this.searchTerm.trim().length === 0) {
                    return this.stock;
                }
                const term = this.searchTerm.toLowerCase();
                return this.stock.filter(item =>
                    (item.productDescription && item.productDescription.toLowerCase().includes(term)) ||
                    (item.productCode && item.productCode.toLowerCase().includes(term))
                );
            }
        }
    };
</script>
